var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"is-relative",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_vm._v(" "),(_vm.hideData)?_c('span',{staticClass:"sensitive_data"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }